const oidc = {
    aborted: 'エンドユーザが操作を中止しました。',
    invalid_scope: 'スコープが無効です: {{error_description}}。',
    invalid_token: '提供されたトークンが無効です。',
    invalid_client_metadata: '提供されたクライアントメタデータが無効です。',
    insufficient_scope: 'トークンにスコープ `{{scope}}` が含まれていません。',
    invalid_request: 'リクエストが無効です。',
    invalid_grant: '付与リクエストが無効です。',
    invalid_issuer: '無効な発行者です。',
    invalid_redirect_uri: '`` `redirect_uri`` `は、クライアントが登録したいずれのものとも一致しませんでした```redirect_uris`。',
    access_denied: 'アクセスが拒否されました。',
    invalid_target: '無効なリソース指示子です。',
    unsupported_grant_type: '要求された`grant_type`はサポートされていません。',
    unsupported_response_mode: '要求された`response_mode`はサポートされていません。',
    unsupported_response_type: '要求された`response_type`はサポートされていません。',
    provider_error: 'OIDC内部エラー:{{message}}。',
    server_error: '不明なOIDCエラーが発生しました。後でもう一度お試しください。',
    provider_error_fallback: 'OIDCエラーが発生しました: {{code}}。',
    custom_claims_script_error: 'カスタム claims スクリプトエラー: {{error_description}}',
    key_required: '少なくとも1つのキーが必要です。',
    key_not_found: 'IDが{{id}}のキーが見つかりません。',
    only_previous_key_can_be_deleted: '削除できるのは Previous キーのみです。',
    invalid_session_payload: '無効なセッションペイロード。',
    session_not_found: 'セッションが見つかりません。',
    invalid_session_account_id: 'セッションの accountId が一致しません。',
    failed_to_revoke_grant: 'グラントの失効に失敗しました。',
    failed_to_cleanup_session_authorization: 'セッション認可のクリーンアップに失敗しました。',
};
export default Object.freeze(oidc);
